import useIdentity from "@/features/ui/hooks/use-identity";

// 바이어가 이 키를 features 에 보유하면 오더시트에서 크림·포이즌 가격비교를 볼 수 있다.
export const ORDER_SHEET_MARKET_PRICE_FEATURE = "ORDER_SHEET_MARKET_PRICE";

/**
 * 오더시트 가격비교(크림·포이즌 시세) 노출 여부 — 모든 바이어(2026-11-04).
 * 처음엔 패스픽 멤버십으로, 그 뒤엔 features 의 ORDER_SHEET_MARKET_PRICE 로 열었는데 이제 바이어면 전부 연다.
 * 서버(views/line_sheet_market_prices)도 같은 판정이다. 키 상수는 기존 features 값과의 호환을 위해 남겨 둔다.
 */
export default function useOrderSheetMarketPriceEnabled(): boolean {
  const identity = useIdentity();
  return identity?.company?.type === "BUYER";
}
